import axios from 'axios'
import { 
  FETCH_SEASONS, 
  FETCH_INTERVALS,
  SELECT_INTERVAL, 
  INTERVAL_ERROR
} from "./types"
import { ROOT_URL } from '../constants'
const Materialize = window.Materialize;
const $ = window.$

function error(err) {
  Materialize.toast(err, 4000, 'rounded red');
  return {
    type: INTERVAL_ERROR,
    err
  };
}
/**
* fetchIntervals: fetches the harvest intervals for a given season
* @param {String} season, ex: 2021-22, 2022-23
* @param {String} email
* @param {Boolean} report
* @returns {Array} intervals
* @called-in: ['/interval/interval_view.js]
**/
export function fetchIntervals({ season, email, report }) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchIntervals`, {
      headers: { authorization: localStorage.getItem('token')  },
      params: { season, email, report }
    }).then((res) => res.data)
      .then((res) => {
        $('#preloader').css('display','none');
        if (report === 1) Materialize.toast(`Report for Season: ${season} fetched!`, 4000, 'rounded green');
        dispatch({ type: FETCH_INTERVALS, payload: res.data }) 
      })
      .catch((err) => dispatch(error(`There was an error fetching data for dashboard: ${err}`)))
  }
}
/**
* fetchSeasonss: fetches the seasons since 2019-20
* @returns {Array} seasons
* @called-in: ['/interval/interval_view.js]
**/
export function fetchSeasons() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchSeasons`, {
      headers: { authorization: localStorage.getItem('token') },
    }).then((res) => res.data)
      .then((res) => {
        dispatch({ type: FETCH_SEASONS, payload: res.seasons }) 
      }).catch((err) => dispatch(error(`There was an error fetching seasons: ${err}`)))
  }
}

export function selectInterval({ interval, loc }) {
  return {
    type: SELECT_INTERVAL,
    payload: interval,
    loc
  }
}





















/* END */


// WEBPACK FOOTER //
// ./src/interval/interval_actions.js